import { enableProdMode, PlatformRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as am4core from '@amcharts/amcharts4/core';

import { AppModule } from './app/app.module';
import { configureDayJs } from './dayjs';
import DataDogConfig from './config/data-dog.config';
import { addGtmToPage } from './gtm';
import { environment } from './environments/environment';
import { Config, CONFIG, prepareConfig } from './config.token';

configureDayJs();

if (environment.production) {
    enableProdMode();
    DataDogConfig.init();

    if (environment.gtmCode) {
        addGtmToPage(environment.gtmCode);
    }
} else {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    Error.stackTraceLimit = Infinity;
}

am4core.options.commercialLicense = true;
fetch('/config.json')
    .then(response => response.json())
    .then((appConfig: Config) => {
        const externalConfig = (!appConfig || Object.keys(appConfig).length === 0)
            ? undefined
            : appConfig;

        am4core.options.commercialLicense = true;
        const platform: PlatformRef = platformBrowserDynamic([
            { provide: CONFIG, useValue: prepareConfig(externalConfig) }
        ]);

        platform.bootstrapModule(AppModule);
    })
    .catch(err => {
        console.log('Application was not initialized', err);
    });

